/**
 * Shared Plausible analytics helper.
 *
 * All custom-event tracking should go through `trackEvent` so that
 * event names stay stable (dynamic data belongs in `props`).
 */
export function trackEvent(
  eventName: string,
  props?: Record<string, string | number | boolean>,
) {
  if (typeof window !== "undefined" && (window as any).plausible) {
    (window as any).plausible(eventName, props ? { props } : undefined);
  }
}
